import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { QuillInputField } from 'components/form';
import { ReviewAndSendFields } from './ReviewAndSendFields';
import { FormSectionHeader } from 'components/shared/FormSectionHeader';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { DealBuilderFormValues, StepComponentProps } from 'modules/dealBuilder';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { useDealBuilderPreviewAndSubmit } from 'modules/dealBuilder/hooks/useDealBuilderPreviewAndSubmit';

export const ReviewAndSendStep = ({ navigationNode }: StepComponentProps) => {
  const { isPreviewLoading, handlePreview } = useDealBuilderPreviewAndSubmit();
  const { control, setValue, getValues } = useFormContext<DealBuilderFormValues>();

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [linkToProposalPage, setLinkToProposalPage] = useState<string | null>(null);

  const handleTogglePreview = async (sectionValue: string, isOpen: boolean) => {
    setIsPreviewOpen(isOpen);

    if (isOpen) {
      const linkToProposalPage = await handlePreview();
      setLinkToProposalPage(linkToProposalPage);
    }
  };

  return (
    <CardContainer
      title="Review & Send"
      subTitle="Please review the quote details and add any notes for the customer before sending."
    >
      <Stack gap={2}>
        <Stack gap={1}>
          <FormSectionHeader name="Notes To Buyer" value="notesToBuyer" />

          <QuillInputField
            control={control}
            setValue={setValue}
            getValues={getValues}
            name="reviewSend.notesToBuyer"
            placeholder="Add notes that will be visible to the buyer..."
          />
        </Stack>

        <Stack gap={1}>
          <FormSectionHeader
            name="Quote Review"
            value="quoteReview"
            isSectionOpen={isPreviewOpen}
            handleUpdateOpenStatus={handleTogglePreview}
          />

          <RenderWithCondition condition={isPreviewOpen}>
            {isPreviewLoading && <Stack>Loading preview...</Stack>}

            {linkToProposalPage && (
              <iframe
                id="dealBuilderPreviewIframe"
                style={{ height: '80vh', minHeight: 600, border: 'none', display: 'block' }}
                /* sandbox={'allow-scripts allow-top-navigation allow-same-origin'} */
                src={linkToProposalPage}
              />
            )}
          </RenderWithCondition>
        </Stack>

        <ReviewAndSendFields />

        {navigationNode()}
      </Stack>
    </CardContainer>
  );
};
